import React from "react"
import styled from "styled-components"
import themeGet from "@styled-system/theme-get"
import { withi18n } from "@/helpers/hoc/withi18n"
import { routes } from "@/helpers"
import { Text } from "@xingternal/winery-ui/lib/Text"

const i18n = {
  about: "360_RECRUITER_INSIGHTS_FOOTER_ABOUT",
  privacyPolicy: "360_RECRUITER_INSIGHTS_FOOTER_PRIVACY_POLICY",
  copyright: "360_RECRUITER_INSIGHTS_FOOTER_RIGHTS",
  security: "360_RECRUITER_INSIGHTS_FOOTER_SECURITY",
  termsAndConditions: "360_RECRUITER_INSIGHTS_FOOTER_TERMS_AND_CONDITIONS",
}

const FooterContainer = styled.div`
  text-align: center;
  padding: ${themeGet("space.5")};
`

const FooterLinks = styled.div`
  margin-bottom: ${themeGet("space.2")};
`

const FooterLink = styled(Text).attrs({
  as: "a",
})`
  font-weight: bold;
  color: ${themeGet("colors.grey600")};

  &:not(:last-child) {
    margin-right: ${themeGet("space.3")};
  }
`

const FooterCopyright = styled(Text)`
  color: ${themeGet("colors.grey600")};
`

const FooterLegal = (i18n) => (
  <FooterContainer>
    <FooterLinks>
      <FooterLink href={routes.about}>{i18n.about}</FooterLink>
      <FooterLink href={routes.termsAndConditions}>
        {i18n.termsAndConditions}
      </FooterLink>
      <FooterLink href={routes.privacyPolicy}>{i18n.privacyPolicy}</FooterLink>
      <FooterLink href={routes.security}>{i18n.security}</FooterLink>
    </FooterLinks>
    <FooterCopyright>{i18n.copyright}</FooterCopyright>
  </FooterContainer>
)

const enhanced = withi18n(i18n)

export default enhanced(FooterLegal)
